module.exports = __webpack_public_path__ + "static/img/WeChat.774c36e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/WeChat.jpg
// module id = 586
// module chunks = 1 5